/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Position_Applicable_TypesInputs */

const vi_warehouse_position_applicable_types = /** @type {(inputs: Warehouse_Position_Applicable_TypesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Áp dụng cho`)
};

/**

* @param {Warehouse_Position_Applicable_TypesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_position_applicable_types = /** @type {((inputs?: Warehouse_Position_Applicable_TypesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Position_Applicable_TypesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_position_applicable_types(inputs)
});